import * as IconSelector from '../icons';

export const tipoPartida = [
    {
        value: 'Gasto',
        label: 'Gasto',
        description: 'Es un gasto',
        icon: IconSelector.PointIcon,
        color: 'Red'
    },
    {
        value: 'Ingreso',
        label: 'Ingreso',
        description: 'Es un Ingreso',
        icon: IconSelector.PointIcon,
        color: 'Green'
    }
];
